import { Injectable } from '@angular/core';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { AuthorizationsService } from './authorizations.service';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import { defer, Observable, of } from 'rxjs';
import { IAppAuthorizations, IUiAuthorizations } from './state';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationsAsync {
  private readonly latestRequestByMode: Record<'relaxed' | 'strict', number> = {
    relaxed: 0,
    strict: 0
  };

  constructor(private readonly lux: Lux<{ appUiAuth: IAppAuthorizations }>, private readonly authService: AuthorizationsService) {
  }

  getAuthorizations(authMode: 'relaxed' | 'strict', context: string): Observable<IUiAuthorizations | null> {
    return defer(() => {
      const requestId = ++this.latestRequestByMode[authMode];

      this.lux.set(state => state.appUiAuth, {
        isFetchingUiAuth: true,
        ...(authMode === 'strict') && { strictMode: {} }
      });

      return of('').pipe(
        mergeMap(() => this.authService.getAuthorizations(authMode, context)),
        tap(uiAuth => {
          if (!this.isLatestRequest(authMode, requestId)) {
            return;
          }

          this.lux.set(state => state.appUiAuth, {
            isFetchingUiAuth: false,
            ...(authMode === 'relaxed') && { relaxedMode: uiAuth || {} },
            ...(authMode === 'strict') && { strictMode: uiAuth || {} }
          });
        }),
        catchError(_err => {
          if (this.isLatestRequest(authMode, requestId)) {
            this.lux.set(state => state.appUiAuth, {
              isFetchingUiAuth: false,
              ...(authMode === 'relaxed') && { relaxedMode: {} },
              ...(authMode === 'strict') && { strictMode: {} }
            });
          }

          return of(null);
        })
      );
    });
  }

  private isLatestRequest(authMode: 'relaxed' | 'strict', requestId: number): boolean {
    return this.latestRequestByMode[authMode] === requestId;
  }

}
